export default (node) => {
  const languageButtons = node.querySelectorAll('[data-language-button]');
  const selectedLanguageInput = node.querySelector('[data-selected-language]');
  const localizationForm = node.querySelector('form[action="/localization"]');
  const closeButton = node.querySelector('[data-close-button]');
  const shopNowButton = node.querySelector('[data-shop-now-button]');
  const overlay = document.querySelector('[data-language-popup-overlay]');
  const changeCountryButton = node.querySelector('[data-change-button]');
  const countrySelectorWrapper = node.querySelector(
    '[data-country-selector-wrapper]'
  );
  const mainTitle = node.querySelector('[data-main-title]');
  const secondaryTitle = node.querySelector('[data-secondary-title]');
  const thirdTitle = node.querySelector('[data-third-title]');
  const saveButton = node.querySelector('[data-save-button]');
  const countriesInformation = node.querySelectorAll(
    '[data-countries-information]'
  );
  const countriesInformationWrapper = node.querySelector(
    '[data-countries-information-wrapper]'
  );
  const delay = node.getAttribute('data-delay');

  const handleLanguageClick = (button) => {
    // Remove 'active' styling from all buttons
    languageButtons.forEach((btn) => {
      btn.classList.remove('bg-surface-secondary', 'border-control-active');
    });

    // Add 'active' styling to the clicked button
    button.classList.add('bg-surface-secondary', 'border-control-active');

    // Update the hidden input value
    if (selectedLanguageInput) {
      selectedLanguageInput.value = button.getAttribute('data-language');
    }
  };

  const handleSaveClick = () => {
    if (!localizationForm) {
      return;
    }

    localizationForm.submit();
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    // Hide the popup
    node.classList.add('opacity-0');
    node.classList.remove('!translate-y-0');
    overlay.classList.add('hidden');
    setTimeout(() => {
      node.classList.add('hidden');
    }, 100);

    if (
      e.currentTarget.dataset.closeButton ||
      e.currentTarget.dataset.shopNowButton
    ) {
      localStorage.setItem('location_popup_country_hide', 'true');
    }

    setTimeout(() => {
      changeCurrentView(true);
    }, 1000);
  };

  const openPopup = () => {
    const hidePopup = localStorage.getItem('location_popup_country_hide');

    let delayTime = delay;

    if (hidePopup) {
      delayTime = 0;
      changeCurrentView(false, true);
    }

    node.classList.remove('hidden');
    setTimeout(() => {
      node.classList.add('!translate-y-0');
      node.classList.remove('opacity-0');
      overlay.classList.remove('hidden');
    }, delayTime);
  };

  const getCountry = async () => {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();

    const country = data?.detected_values?.country?.handle || 'CA';

    if (country) {
      countriesInformation.forEach((info) => {
        if (info.dataset.countriesInformation.includes(country)) {
          info.classList.remove('hidden');
        }
      });
    }

    return data?.detected_values?.country?.name || 'CA';
  };

  const changeCurrentView = (originalView = false, showThirdTitle = false) => {
    if (originalView) {
      countrySelectorWrapper.classList.add('hidden');
      shopNowButton.classList.remove('hidden');
      changeCountryButton.classList.remove('hidden');
      saveButton.classList.add('hidden');
      mainTitle.classList.remove('hidden');
      secondaryTitle.classList.add('hidden');
      thirdTitle.classList.add('hidden');
      countriesInformationWrapper.classList.remove('hidden');
    } else {
      countrySelectorWrapper.classList.remove('hidden');
      shopNowButton.classList.add('hidden');
      changeCountryButton.classList.add('hidden');
      saveButton.classList.remove('hidden');
      mainTitle.classList.add('hidden');
      countriesInformationWrapper.classList.add('hidden');
      if (showThirdTitle) {
        thirdTitle.classList.remove('hidden');
        secondaryTitle.classList.add('hidden');
      } else {
        secondaryTitle.classList.remove('hidden');
        thirdTitle.classList.add('hidden');
      }
    }
  };

  const handleChangeCountryClick = (e) => {
    e.preventDefault();
    changeCurrentView();
  };

  const init = async () => {
    document.addEventListener('language-popup:open', openPopup);

    const country = await getCountry();
    const countryElement = node.querySelector('[data-location-popup-country]');
    if (countryElement) {
      countryElement.textContent = country;
    }

    if (languageButtons.length) {
      languageButtons.forEach((button) => {
        button.addEventListener('click', () => handleLanguageClick(button));
      });
    }

    const saveButton = node.querySelector('.save-button');
    if (saveButton) {
      saveButton.addEventListener('click', handleSaveClick);
    }

    if (closeButton) {
      closeButton.addEventListener('click', handleCloseClick);
    }

    if (shopNowButton) {
      shopNowButton.addEventListener('click', handleCloseClick);
    }

    if (changeCountryButton) {
      changeCountryButton.addEventListener('click', handleChangeCountryClick);
    }

    if (overlay) {
      overlay.addEventListener('click', handleCloseClick);
    }

    const hidePopup = localStorage.getItem('location_popup_country_hide');

    if (!hidePopup) {
      setTimeout(() => {
        openPopup();
      }, 200);
    }
  };

  init();
};
